import { defineMessages } from "react-intl";

export const messages = defineMessages({
  installApp: {
    id: "2cjt25",
    defaultMessage: "Install App",
    description: "window title",
  },
});
